import {
  createRouter,
  createWebHistory
} from 'vue-router'

const CreateUserAccount = () => import('../views/User/CreateUserAccount.vue')
const ListCartItems = () => import('../views/Cart/ListCartItems.vue')
const ListCheckoutPayments = () => import('../views/Checkout/ListCheckoutPayments.vue')
const ListEvents = () => import('../views/Event/ListEvents.vue')
const ListOrders = () => import('../views/Order/ListOrders.vue')
const UpdateUser = () => import('../views/User/UpdateUser.vue')
const UpdateUserAuth = () => import('../views/User/UpdateUserAuth.vue')
const ViewUserConfirmRegister = () => import('../views/User/ViewUserConfirmRegister.vue')
const ViewEvent = () => import('../views/Event/ViewEvent.vue')
const ViewEventProducts = () => import('../views/Event/ViewEventProducts.vue')
const ViewLogin = () => import('../views/Auth/ViewUserLogin.vue')
const ViewUserLoginOptions = () => import('../views/Auth/ViewUserLoginOptions.vue')
const ViewUserLogout = () => import('../views/Auth/ViewUserLogout.vue')
const ViewUserForgotPassword = () => import('../views/Auth/ViewUserForgotPassword.vue')
const ViewOrder = () => import('../views/Order/ViewOrder.vue')
const ViewOrderSummary = () => import('../views/Checkout/ViewOrderSummary.vue')

const routes = [
    // {
    //     path: '/event/list',
    //     name: 'List Events',
    //     component: Home
    // }
    {
        path: '/',
        name: 'Home',
        component: ListEvents,
        meta: { layout: 'default' }
    },
    {
        path: '/event/:id',
        name: 'Evento',
        component: ViewEvent,
        meta: { layout: 'event-page' }
    },
    {
        path: '/event-products/:id',
        name: 'Produtos do Evento',
        component: ViewEventProducts,
        meta: { layout: 'event-page' }
    },
    {
        path: '/cart',
        name: 'Listagem de Produtos do Carrinho',
        component: ListCartItems,
        meta: { layout: 'checkout' }
    },
    {
        path: '/checkout',
        name: 'Listagem de Pagamentos do Checkout',
        component: ListCheckoutPayments,
        meta: { layout: 'checkout' }
    },
    {
        path: '/order-summary/:paymentMethod',
        name: 'Pedido Realizado',
        component: ViewOrderSummary,
        meta: { layout: 'checkout' }
    },
    {
        path: '/login-options',
        name: 'Opções de Login',
        component: ViewUserLoginOptions,
        meta: { layout: 'auth' }
    },
    {
        path: '/login',
        name: 'Logar na Conta',
        component: ViewLogin,
        meta: { layout: 'auth' }
    },
    {
        path: '/logout',
        name: 'Deslogar da Conta',
        component: ViewUserLogout,
        meta: { layout: 'auth' }
    },
    {
        path: '/register',
        name: 'Criar uma Conta',
        component: CreateUserAccount,
        meta: { layout: 'auth' }
    },
    {
        path: '/orders',
        name: 'Listar Pedidos',
        component: ListOrders,
        meta: { layout: 'admin' }
    },
    {
        path: '/order/:id',
        name: 'Visualizar Pedido',
        component: ViewOrder,
        meta: { layout: 'admin' }
    },
    {
        path: '/user',
        name: 'Visualizar Cadastro',
        component: UpdateUser,
        meta: { layout: 'admin' }
    },
    {
        path: '/auth',
        name: 'Visualizar Autenticação',
        component: UpdateUserAuth,
        meta: { layout: 'admin' }
    },
    {
        path: '/user-confirm-register',
        name: 'Confirmar Registro de Usuário',
        component: ViewUserConfirmRegister,
        meta: { layout: 'auth' }
    },
    {
        path: '/user-forgot-password',
        name: 'Esqueci Minha Senha',
        component: ViewUserForgotPassword,
        meta: { layout: 'auth' }
    },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

export default router